<template>
  <WLabel
    :for="_.uid"
    class="h-pill__button"
    :class="{ selected: checked }"
    :disabled="shouldDisabled"
  >
    <img :src="image" :alt="name" class="h-pill__button__image" />
    <input
      :id="_.uid"
      :name="name"
      :aria-label="name"
      :required="required && !disabled"
      type="radio"
      :checked="shouldCheck"
      @change="handleChange"
    />
  </WLabel>
</template>
<script>
import { WLabel } from '@alice-health/wonderland-vue'

export default {
  components: { WLabel },
  props: {
    name: {
      type: String,
      default: 'pill-button'
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: '',
      required: true
    }
  },
  emits: ['change'],
  data() {
    return {
      inputId: null
    }
  },
  computed: {
    shouldCheck() {
      return this.checked || null
    },
    shouldDisabled() {
      return this.disabled || null
    }
  },
  created() {
    this.inputId = this.id || this._.uid
  },
  methods: {
    handleChange(event) {
      this.$emit('change', event)
    }
  }
}
</script>
<style scoped lang="scss">
.h-pill__button {
  position: relative;
  background: var(--gl-color-shades-white);
  border: var(--gl-border-width-xs) solid var(--sys-color-stroke-active);
  border-radius: var(--gl-border-radius-md);
  text-align: center;
  cursor: pointer;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0;
  width: 80px;
  overflow: auto;
  margin: var(--gl-spacing-02);
  height: 80px;

  &:hover {
    background: var(--gl-color-shades-magenta-00);
    filter: none;
    outline: 1px solid var(--sys-color-stroke-hover);
  }
  &.selected {
    background: var(--gl-color-shades-magenta-00);
    border: var(--gl-border-width-xs) solid
      var(--sys-color-stroke-active-variant);
    outline: none;
  }

  &:focus {
    filter: none;
  }

  &[disabled] {
    cursor: not-allowed;
    background: var(--sys-color-surface-background-light);
    border: var(--gl-border-width-xs) solid var(--sys-color-stroke-disabled);
    color: var(--sys-color-content-disabled);
  }

  input {
    opacity: 0;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  &__image {
    height: 80px;
    cursor: pointer;
    object-fit: cover;
    margin-top: 6px;
  }
}
</style>
